import React from 'react';
import type { Serie } from '../services/seriesService';
import styles from './SerieCard.module.css';

interface SerieCardProps {
  serie: Serie;
  onEdit: (serie: Serie) => void;
  onToggleAtiva: (serie: Serie) => void;
  onDelete: (serie: Serie) => void;
}

// Função para formatar valor como moeda brasileira
const formatCurrency = (value: number): string => {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
};

// Função para formatar data
const formatDate = (dateString: string): string => {
  return new Date(dateString).toLocaleDateString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
};

export const SerieCard: React.FC<SerieCardProps> = ({
  serie,
  onEdit,
  onToggleAtiva,
  onDelete,
}) => {
  return (
    <div className={`${styles.cardContainer} ${!serie.ativa ? styles['cardContainer--inactive'] : ''}`}>
      <div className={styles.cardHeader}>
        <h3 className={styles.serieTitle}>{serie.nome}</h3>
        <span className={`${styles.statusBadge} ${serie.ativa ? styles['statusBadge--active'] : styles['statusBadge--inactive']}`}>
          {serie.ativa ? 'Ativa' : 'Inativa'}
        </span>
      </div>

      <span className={`${styles.tipoBadge} ${serie.tipoEnsino === 'curricular' ? styles['tipoBadge--curricular'] : styles['tipoBadge--extracurricular']}`}>
        {serie.tipoEnsino === 'curricular' ? '📚 Curricular' : '🎯 Extracurricular'}
      </span>

      <span className={styles.segmentoBadge}>
        🏫 {serie.segmento ?? 'N/A'}
      </span>

      <div className={styles.valorContainer}>
        <div className={styles.valorLabel}>Valor da Mensalidade</div>
        <div className={styles.valorAmount}>{formatCurrency(serie.valorMensalidade)}</div>
      </div>

      <div className={styles.valorContainer}>
        <div className={styles.valorLabel}>Valor Material Didático</div>
        <div className={styles.valorAmount}>{formatCurrency(serie.valorMaterialDidatico ?? 0)}</div>
      </div>

      <div className={styles.valorContainer}>
        <div className={styles.valorLabel}>Codigo NFSe</div>
        <div className={styles.valorAmount}>
          {serie.codigoServico
            ? `${serie.codigoServico.codigoAtividade} (${serie.codigoServico.codigoServico})`
            : 'Nao definido'}
        </div>
      </div>

      <div className={styles.actionsContainer}>
        <button
          className={`${styles.actionButton} ${styles['actionButton--edit']}`}
          onClick={() => onEdit(serie)}
          title="Editar série"
        >
          ✏️ Editar
        </button>

        <button
          className={`${styles.actionButton} ${styles['actionButton--toggle']}`}
          onClick={() => onToggleAtiva(serie)}
          title={serie.ativa ? 'Desativar série' : 'Ativar série'}
        >
          {serie.ativa ? '🔒 Desativar' : '🔓 Ativar'}
        </button>

        <button
          className={`${styles.actionButton} ${styles['actionButton--delete']}`}
          onClick={() => onDelete(serie)}
          title="Excluir série"
        >
          🗑️ Excluir
        </button>
      </div>

      <div className={styles.metaInfo}>
        <span>Ordem: {serie.ordem}</span>
        <span>Criada: {formatDate(serie.criadaEm)}</span>
        <span>ID: #{serie.id}</span>
      </div>
    </div>
  );
};
